document.addEventListener('DOMContentLoaded', () => {
    const loadMoreButton = document.getElementById('load-more');

    if (loadMoreButton) {
        loadMoreButton.addEventListener('click', async () => {
            const currentPage = parseInt(loadMoreButton.getAttribute('data-current-page'));
            const maxPages = parseInt(loadMoreButton.getAttribute('data-max-pages'));

            if (currentPage < maxPages) {
                const nextPage = currentPage + 1;

                try {
                    const response = await fetch(`${window.location.pathname}?page=${nextPage}`);
                    const text = await response.text();
                    const parser = new DOMParser();
                    const doc = parser.parseFromString(text, 'text/html');
                    const newArticles = doc.querySelectorAll('.blog--inner .article--excerpt-wrapper');

                    newArticles.forEach(article => {
                        document.getElementById('articles').appendChild(article);
                    });

                    loadMoreButton.setAttribute('data-current-page', nextPage);

                    if (nextPage >= maxPages) {
                        loadMoreButton.style.display = 'none';
                    }
                } catch (error) {
                    console.error('Failed to load more articles', error);
                }
            }
        });
    }
});